import React from "react";
import MTechVideo from "../assets/video/mobile/mobile_KV15.mp4";
import TTechVideo from "../assets/video/tablet/tablet_KV15.mp4";
import DTechVideo from "../assets/video/desktop/desktop_KV15.mp4";
import RenderVideo from "./RenderVideo";

const SectionTechnology = ({
  heading,
  content,
  content_2,
  content_3,
  id = "",
}) => {
  return (
    <div className="relative w-screen xl:h-[1080px] lg:h-[768px] md:h-[1194px] h-[812px] text-white overflow-hidden">
      <RenderVideo
        id={id}
        videoM={MTechVideo}
        videoT={TTechVideo}
        videoD={DTechVideo}
        classList={
          "max-w-[1920px] lg:left-1/2 lg:-translate-x-1/2 absolute object-cover h-full object-cover w-screen -z-[1]"
        }
      />
      <div className="container lg:pt-[75px] md:pt-[95px] pt-[70px]">
        <h2
          className="md:max-w-[480px] lg:text-5xl md:text-5xl text-3xl md:mb-[40px] mb-[25px]"
          data-aos="fade-up"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          {heading}
        </h2>
        <p
          className="lg:text-lg md:max-w-[600px]"
          data-aos="fade-up"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          {content}
        </p>
        <br />
        <p
          className="lg:text-lg md:max-w-[600px]"
          data-aos="fade-up"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          {content_2}
        </p>
        <br />
        <p
          className="lg:text-lg md:max-w-[600px]"
          data-aos="fade-up"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
        >
          {content_3}
        </p>
      </div>
    </div>
  );
};

export default SectionTechnology;
